import { render, staticRenderFns } from "./ProductInquiryCore.vue?vue&type=template&id=34259378&scoped=true&"
import script from "./ProductInquiryCore.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiryCore.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInquiryCore.vue?vue&type=style&index=0&id=34259378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34259378",
  null
  
)

export default component.exports